import React from "react";
import DateTimePicker from "./CreateEvent/DateTimePicker";

type DateRangePickerProps = {
	startDate: string;
	endDate: string;
	onStartChange: (value: string) => void;
	onEndChange: (value: string) => void;
	onReset?: () => void;
	className?: string;
	startLabel?: string;
	endLabel?: string;
	idPrefix?: string;
};

const DateRangePicker: React.FC<DateRangePickerProps> = ({
	startDate,
	endDate,
	onStartChange,
	onEndChange,
	onReset,
	className = "",
	startLabel = "開始日",
	endLabel = "終了日",
	idPrefix = "date-range",
}) => {
	return (
		<div className={`flex flex-wrap items-end gap-4 ${className}`}>
			<div className="flex-1 min-w-[230px]">
				<DateTimePicker
					value={startDate}
					onChange={onStartChange}
					label={startLabel}
					id={`${idPrefix}-start`}
					dateOnly
					placeholder="開始日を選択"
				/>
			</div>

			<div className="pb-6 text-gray-500 font-medium">〜</div>

			<div className="flex-1 min-w-[230px]">
				<DateTimePicker
					value={endDate}
					onChange={onEndChange}
					label={endLabel}
					id={`${idPrefix}-end`}
					dateOnly
					placeholder="終了日を選択"
				/>
			</div>

			{onReset && (
				<button
					type="button"
					onClick={onReset}
					className="ml-2 px-3 sm:px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 whitespace-nowrap transition-colors"
				>
					リセット
				</button>
			)}
		</div>
	);
};

export default DateRangePicker;
